import React from 'react';
import styled from 'styled-components';

const lineHeightByFontSize = (fontSize) =>
  ({
    '16px': '23px',
    '36px': '50px',
    '44px': '62px',
    default: 'normal',
  }[fontSize || 'default']);

const Title = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: ${({ fontSize }) => fontSize || '42px'};
  line-height: ${({ fontSize }) => lineHeightByFontSize(fontSize || '42px')};
  color: ${({ ColorMain }) => (ColorMain ? ColorMain : '#1B1C29')};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : '500')};
  position: relative;
  text-align: ${({ centerMode, right }) => (centerMode ? 'center' : right ? 'right' : 'left')};

  ${({ letterSpacing }) => (letterSpacing ? `letter-spacing: ${letterSpacing};` : '')}
  ${({ centerMode }) => (centerMode ? 'display: inline-block' : null)}

  @media(max-width: 1280px) {
    br {
      display: none;
    }
  }

  @media (max-width: 768px) {
    margin: 1.4rem 0;
  }

  span {
    font-weight: ${({ spanWeight }) => (spanWeight ? spanWeight : '500')};
    color: ${({ ColorTheme, spanColor, theme }) => spanColor || ColorTheme || theme.colors.purple};
  }
`;

const Flex = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${({ centerMode }) => (centerMode ? 'center' : 'start')};
`;

const Hr = styled.hr`
  width: 64px;
  height: 3px;
  background-color: ${({ ColorTheme, theme }) => (ColorTheme ? ColorTheme : theme.colors.purple)};
  margin: ${({ centerMode }) => (centerMode ? '0 auto 24px auto' : '0 0 24px 0')};
  border: none;
  display: ${({ hrNotVisible }) => (hrNotVisible ? 'none' : 'auto')};
`;

const SectionTitle = ({
  children,
  fontSize,
  ColorMain,
  fontWeight,
  right,
  ColorTheme,
  centerMode,
  spanColor,
  spanWeight,
  letterSpacing,
  hrNotVisible,
  as,
}) => (
  <Flex centerMode={centerMode}>
    <Hr ColorTheme={ColorTheme} centerMode={centerMode} hrNotVisible={hrNotVisible} />
    <Title
      as={as}
      fontSize={fontSize}
      ColorMain={ColorMain}
      ColorTheme={ColorTheme}
      right={right}
      centerMode={centerMode}
      spanColor={spanColor}
      fontWeight={fontWeight}
      spanWeight={spanWeight}
      letterSpacing={letterSpacing}
    >
      {children}
    </Title>
  </Flex>
);

export default SectionTitle;
